import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";
import styles from "../styles";
import Dodavanje from "./Dodavanje";
import axios from "axios";

const SIGNATURE_URL = "https://data.nadzor.app/potpis.jpg";

function PreviewGradiliste({
  gradilisteId,
  setGradilisteId,
  godina,
  mesec,
  setGodina,
  setMesec,
}) {
  const [dani, setDani] = useState([]);
  const [gradiliste, setGradiliste] = useState(null);
  const [isAzuriranje, setIsAzuriranje] = useState(false);
  const { dictionary, baseUrl, selectedMainEntity, loggedUser, apiKey } = useGlobalContext();
  const [header, setHeader] = useState({ name: "", address: "", pib: "" });

  const fetchDani = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija7/get_dani.php`, {
        gradiliste_id: gradilisteId,
        godina,
        mesec,
      });
      if (data.status === 200) setDani(data.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!gradilisteId) return;
    fetchDani();
    // Dohvati naziv gradilista
    const fetchGradiliste = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/evidencija7/get_gradilista.php`,
          {
            company_id: selectedMainEntity.company_id,
          }
        );
        if (data.status === 200) {
          const g = data.data.find(
            (x) => String(x.id) === String(gradilisteId)
          );
          if (g) setGradiliste(g);
        }
      } catch (e) {
        console.error(e);
      }
    };
    fetchGradiliste();
  }, [gradilisteId, godina, mesec]);

  useEffect(() => {
    const fetchHeader = async () => {
      const id = selectedMainEntity?.company_id || selectedMainEntity?.id;
      if (!id || !loggedUser?.id) return;
      try {
        const { data: res } = await axios.post(
          `${baseUrl}/companies/readCompanyDetails.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
            company_id: id,
          }
        );
        if (res.status === 200)
          setHeader({
            name: res.data.company_name,
            address: res.data.company_address,
            pib: res.data.pib,
          });
      } catch (e) {
        console.error(e);
      }
    };
    fetchHeader();
  }, [selectedMainEntity, loggedUser?.id]);

  const handleOdustani = () => {
    const isCurrent =
      new Date().getMonth() + 1 == mesec && new Date().getFullYear() == godina;
    if (isCurrent) {
      setGradilisteId("");
    } else {
      setGodina(-1);
      setMesec(-1);
    }
  };

  const handleStampaj = () => {
    const el = document.getElementById("print-gradiliste");
    if (!el) return;
    const useSignature = window.confirm(
      "Da li želite da dodate stranicu sa potpisom?"
    );
    let signatureHtml = "";
    if (useSignature) {
      signatureHtml = `<div style="page-break-before:always;"><div style="width:190mm;height:277mm;margin:0 auto;position:relative;background:#fff;"><img src="${SIGNATURE_URL}" style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:block;"/></div></div>`;
    }
    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Popup blokiran.");
      return;
    }
    printWindow.document.write(
      `<html><head><meta charset="utf-8"/><style>@page{size:A4 portrait;margin:15mm;}body{margin:0;padding:0;font-family:sans-serif;font-size:12px;}#print-gradiliste{padding:0!important;border:none!important;}table{width:100%;border-collapse:collapse;table-layout:fixed;}td{border:1px solid #000;padding:4px 6px;font-size:12px;vertical-align:top;word-wrap:break-word;}hr{width:80%;margin:0 auto 5px;border:0;border-top:1px solid #000;}</style></head><body>${el.innerHTML}${signatureHtml}</body></html>`
    );
    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  const getDayRow = (dayNum) =>
    dani.find((x) => Number(x.dan) === Number(dayNum)) || null;

  return (
    <>
      <div
        style={{
          overflowY: "auto",
          height: `calc(100% - ${isAzuriranje ? "180" : "120"}px)`,
          backgroundColor: "rgb(204,204,204)",
        }}
      >
        <div
          id="print-gradiliste"
          style={{
            backgroundColor: "white",
            padding: "40px",
            border: "1.5px solid #9f9f9f",
          }}
        >
          <div style={{ fontWeight: "bold", textAlign: "center" }}>
            <div>Образац 7</div>
            <div style={{ fontSize: "13px", marginTop: "5px" }}>
              ЕВИДЕНЦИЈА О ПРИМЕНИ МЕРА ЗА БЕЗБЕДНОСТ И ЗДРАВЉЕ НА РАДУ ЗА
              ДЕЛАТНОСТИ ИЗ ЧЛАНА 48. ЗАКОНА О БЕЗБЕДНОСТИ И ЗДРАВЉУ НА РАДУ
            </div>
          </div>
          <br />
          <br />
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ width: "33%", textAlign: "center" }}>
              {header.name || selectedMainEntity.company_name}
              <hr />
              <span style={{ fontSize: "11px" }}>Пословно име послодавца</span>
            </div>
            <div style={{ width: "33%", textAlign: "center" }}>
              {header.address}
              <hr />
              <span style={{ fontSize: "11px" }}>Адреса седишта послодавca</span>
            </div>
            <div style={{ width: "33%", textAlign: "center" }}>
              {header.pib}
              <hr />
              <span style={{ fontSize: "11px" }}>ПИБ послодавца</span>
            </div>
          </div>
          <br />
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td colSpan={2} style={{ textAlign: "left", padding: "0 5px" }}>
                  Година: {godina}
                </td>
                <td colSpan={1} style={{ textAlign: "left", padding: "0 5px" }}>
                  Месец: {mesec}
                </td>
                <td colSpan={2} style={{ textAlign: "left", padding: "0 5px" }}>
                  Локација (градилиште/одвојена јединица): {gradiliste?.naziv || ""}
                </td>
              </tr>
              <tr style={{ fontWeight: "bold", backgroundColor: "#f9f9f9" }}>
                <td style={{ width: "10%", fontSize: "14px", padding: "2px 5px" }}>Дан у месецу</td>
                <td style={{ width: "22%", fontSize: "14px", padding: "2px 5px" }}>Уочене неправилности</td>
                <td style={{ width: "26%", fontSize: "14px", padding: "2px 5px" }}>Лице одређено за свакодневно праћење и контролу</td>
                <td style={{ width: "27%", fontSize: "14px", padding: "2px 5px" }}>Предлог мера за отклањање неправилности</td>
                <td style={{ width: "15%", fontSize: "14px", padding: "2px 5px" }}>Напомена</td>
              </tr>
              {Array.from({ length: 31 }, (_, idx) => {
                const dayNum = idx + 1;
                const row = getDayRow(dayNum);
                return (
                  <tr key={dayNum}>
                    <td style={{ textAlign: "center" }}>{dayNum}.</td>
                    <td style={{ textAlign: "left" }}>{row?.nepravilnosti || ""}</td>
                    <td style={{ textAlign: "left" }}>{row?.zaposleni_naziv || ""}</td>
                    <td style={{ textAlign: "left" }}>{row?.mere || ""}</td>
                    <td style={{ textAlign: "left" }}>{row?.napomena || ""}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <br />
          <br />
          <div style={{ display: "flex", marginTop: "20px" }}>
            <div style={{ width: "70%", textAlign: "center" }}>
              <hr style={{ width: "80%", margin: "0 auto 5px" }} />
              Саветник/сарадник за безбедност и здравље на раду
            </div>
            <div style={{ width: "30%", textAlign: "center" }}>
              <hr style={{ width: "80%", margin: "0 auto 5px" }} />
              Послодавац
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "15px" }}>
        {isAzuriranje ? (
          <Dodavanje
            handleCancel={() => setIsAzuriranje(false)}
            gradilisteId={gradilisteId}
            godina={godina}
            mesec={mesec}
            onRefresh={fetchDani}
          />
        ) : (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <div onClick={handleStampaj}>
                <Button activation={true} style={styles.button}>
                  {dictionary["stampaj"]}
                </Button>
              </div>
              <div>
                <Button activation={true} style={styles.button}>
                  {dictionary["posalji"]}
                </Button>
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <div onClick={handleOdustani}>
                <Button activation={true} style={styles.button}>
                  {dictionary["odustani"]}
                </Button>
              </div>
              <div onClick={() => setIsAzuriranje(true)}>
                <Button activation={true} style={styles.button}>
                  {dictionary["azuriraj"]}
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default PreviewGradiliste;